// @flow
import * as React from 'react';
import {
    EmailAddressField,
    EmailAddressConfirmField,
    UsernameField,
    PasswordField,
    PasswordConfirmField,
    DefaultPromotionalMethodField, ContactLocaleField, SendConfirmEmailField
} from 'app/default/field';
import Buttons from 'app/default/button';

const UserComponent = () => (
    <form>
        <DefaultPromotionalMethodField />
        <ContactLocaleField />
        <SendConfirmEmailField />
        
        <EmailAddressField />
        <EmailAddressConfirmField />
        <UsernameField />
        <PasswordField />
        <PasswordConfirmField />
        
        <Buttons />
    </form>
);

export default UserComponent;
